export const iconFontAwesomeAutomotiveGasPump = (
	<i className="fa-solid fa-gas-pump"></i>
);
